export default class CarouselCenterButton {
    constructor(el) {
        this.DOM = { el: el };
        this.id = this.DOM.el.id;
        this.DOM.prevButton = document.getElementById(`${this.id}-prev`);
        this.DOM.nextButton = document.getElementById(`${this.id}-next`);
        this.DOM.image = this.DOM.el.querySelector('img');

        this.init();
    }

    init() {
        if (!this.DOM.image) return;

        const buttonHeight = this.DOM.prevButton.offsetHeight;

        const resizeObserver = new ResizeObserver(entries => {
            entries.forEach((entry) => {
                const { height } = entry.contentRect;

                const buttonTopPosition = (height - buttonHeight) / 2;
                this.DOM.prevButton.style.top = `${buttonTopPosition}px`;
                this.DOM.nextButton.style.top = `${buttonTopPosition}px`;
            });
        });

        resizeObserver.observe(this.DOM.image);
    }
}

const carouselNodes = Array.from(document.querySelectorAll('.carousel--center-button'));

carouselNodes.forEach((node) => { new CarouselCenterButton(node); });
